import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { GeneralHelper } from '../../../../../helpers/general.helper';

@Injectable({
  providedIn: 'root'
})
export class ReportService {


  constructor(private http: HttpClient, private generalHelper: GeneralHelper) {}

   private newFilter = new BehaviorSubject(false);

   private filter: BehaviorSubject<any> = new BehaviorSubject('');

    public summary(eventId: string, params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/resumeByEvent/'+eventId+'?'+query);
    }

    listBordero(id) {
      return this.http.get(environment.apiUrl+'/report/bordero/list?eventId='+id);
    }

    public downloadBordero(params: any, options?: any, name?: string) {
      let query = this.generalHelper.buildQuery(params);

      return this.http
              .get(environment.apiUrl+'/report/bordero/download?'+query, {
                ...options
              })
    }

    public listEvent(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/event/?'+query);
    }

    public list2list(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/event/list2list?'+query);
    }

    public listEventOccasions(eventId: string) {
      return this.http.get(environment.apiUrl+'/event/occasions/'+eventId);
    }

    public getSalesCupomByEventForExport(eventId: string) {
      return this.http.get(environment.apiUrl+'/report/getSalesCupomByEventForExport?eventId='+eventId);
    }

    entryMifares(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/entryMifares/?'+query);
    }

    public getSalesSTPP(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/reportSTPP?'+query);
    }

    public getSalesST(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/reportST?'+query);
    }

    public getCheckinST(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/customer/goiasstcheckin?'+query);
    }

    public salesByEvent(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/reportSalesByEvent?'+query);
    }

    public salesListByEvent2List(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/reportSalesListByEvent2List?'+query);
    }

    public salesPDVByEvent(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/reportSalesPDVByEvent?'+query);
    }

    public listEventPdvs(eventId: string, params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/order/read/pdv/'+eventId);
    }

    public salesByPdv(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/reportSalesByPdv?'+query);
    }

    public entries(params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/reportEntries?'+query);
    }

    public exportSalesPDVByEvent(params?: any) {
      let query = this.generalHelper.buildQuery(params);

      return this.http.get(environment.apiUrl+'/report/exportPDV?'+query, { headers: new HttpHeaders().append('Content-Type', 'application/vnd.ms-excel'), responseType: 'blob' });
    }

    public resetEntry(eventId: string) {
      return this.http.get(environment.apiUrl+'/event/resetEntry/'+eventId);
    }

    public resetEntrySubmit(eventId: string, data: any) {
      return this.http.post(environment.apiUrl+'/event/resetEntry/'+eventId, data);
    }

    public moneyExtractPDVByEvent(eventId: string, params?: any) {
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/PDVMoneyExtract/'+eventId+'?'+query);
    }
 
    public transactionByEventPaymentMethod(params: any){
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/orderByPaymentsAndEvent' + '?' + query);
    }

    transactionByPaymentMethod(params: any){
      let query = this.generalHelper.buildQuery(params);
      return this.http.get(environment.apiUrl+'/report/orderByPaymentsAndDate' + '?' + query);
    }

    defineNewFilter(newFilter: boolean) {
      this.newFilter.next(newFilter);
    }

    getNewFilter() {
      return this.newFilter.asObservable();
    }

    defineFilter(filter: any) {
      return this.filter.next(filter);
    }


    getFilter() {
      return this.filter.asObservable();
    }


      public analyticsAge(eventId: string, producerId: string) {
    //   let query = this.generalHelper.buildQuery(params);
        return this.http.get(environment.apiUrl+'/report/reportAnalyticsAge?eventId='+eventId+'&producerId='+producerId);
      }

      public analyticsGender(eventId: string, producerId: string) {
          return this.http.get(environment.apiUrl+'/report/reportAnalyticsGender?eventId='+eventId+'&producerId='+producerId);
      }

      public analyticsState(eventId: string, producerId: string) {
        return this.http.get(environment.apiUrl+'/report/reportAnalyticsState?eventId='+eventId+'&producerId='+producerId)
      }
    
      getCuponsByEvent(params: any){
        let query = this.generalHelper.buildQuery(params);      
        return this.http.get(environment.apiUrl+'/report/getCuponsByEvent?'+query);
      }

  }
